import { css } from 'lit';

export default css`
  :host {
    --private-content-padding: 20px, 24px, 20px, 24px;
  }

  .content {
    width: 100%;
    display: flex;
    flex-direction: column;
    position: relative;
    gap: 32px;
    padding: var(--private-content-padding);
  }

  .row {
    width: 100%;
    display: flex;
    align-items: center;
  }

  .divider {
    width: 100%;
    height: 1px;
    background-color: var(--amityeko-color-gray-8);
  }

  .label {
    flex: 0 0 auto;
    width: 100px;
  }

  .control {
    flex: 1 1 auto;
    width: 100%;
  }

  .control--flex-row {
    display: flex;
    align-items: center;
    gap: 20px;
  }

  input[type='file'] {
    display: none;
  }

  .video__container {
    position: relative;
    cursor: pointer;
  }

  .upload__video {
    position: absolute;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
  }

  amityeko-textarea {
    width: 100%;
    --public-label-width: 100px;
  }

  amityeko-input {
    width: 100%;
    --public-label-width: 100px;
  }

  amityeko-image-selector::part(label),
  amityeko-color-selector::part(label) {
    width: 100px;
  }

  amityeko-image-selector::part(item) {
    border-radius: 4px;
  }

  amityeko-tg-caption::part(base) {
    color: var(--amityeko-color-info-6);
    cursor: pointer;
    position: absolute;
  }

  rnr-image-layout-content {
    width: 140px;
    height: 140px;
    display: var(--private-image-layout-display);
  }

  .gif {
    display: var(--private-gif-display);
  }

  rnr-video {
    width: 150px;
    height: 150px;
  }
`;
